import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FileSizePipe } from '../../shared/file-size.pipe';
import { Authenticate } from '../../models/authenticate';
//import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-file',
  templateUrl: './file.html',
  styleUrls: ['./file.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],

  providers: [
    FileSizePipe
  ]
})
export class File implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;


  submitted = false;
  clicked = false;
  clickedOnce = false;
  changed = false;
  allStates: any = [];
  allCountries: any = [];
  claimantsInformation: FormGroup;
  submittedClaim: Claimant;
  au: Authenticate;
  response: string | undefined;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  cdList: any = [];
  showDivProvince: boolean = false;
  showDivCityStateZip: boolean = true;
  showDivPurchaseUploadDocs: boolean = false;
  showDivDisagreePurchaseMessage: boolean = false;
  showSubmittalErrorWarning: boolean = false;
  selectedCountry: any;
  supportingDocuments: any = [];

  validation_ClaimDetailsErrorMessage = {
    purchaseYear: [
      { type: 'required', message: 'This Field is required' },
    ],
    defendant: [
      { type: 'required', message: 'This Field is required' },
    ],
    purchaseAmount: [
      { type: 'required', message: 'This field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal." }
    ],
  };
  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private claimantService: ClaimantService) { }

  ngOnInit() {
    this.dateLoaded = new Date();
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.loadAllCountries();
    this.claimantsInformation = this.fb.group({
     
      attention: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])],
      postalCode: ['', Validators.compose([Validators.maxLength(10)])],
      province: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      filingType: ['Blank'],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      title: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
      claimDetails: this.fb.array([])
    });
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      console.log(data);
      this.allCountries = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.claimantsInformation.controls; }

  getCountryValue($event) {
    this.changed = true;
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value !== 'United States') {
      this.showDivProvince = true;
      this.showDivCityStateZip = false;

      this.claimantsInformation.get('province').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('province').updateValueAndValidity();

      this.claimantsInformation.get('postalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.claimantsInformation.get('postalCode').updateValueAndValidity();

      this.claimantsInformation.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('city').updateValueAndValidity();
      this.claimantsInformation.get('city').reset();

      this.claimantsInformation.get('state').reset();
      this.claimantsInformation.get('state').clearValidators();
      this.claimantsInformation.get('state').updateValueAndValidity();
      this.claimantsInformation.get('zip').reset();
      this.claimantsInformation.get('zip').clearValidators();
      this.claimantsInformation.get('zip').updateValueAndValidity();
    }

    if ($event.target.value === 'United States') {
      /* */
      this.showDivProvince = false;
      this.showDivCityStateZip = true;
      this.claimantsInformation.get('state').setValidators(Validators.compose([Validators.required]));
      this.claimantsInformation.get('state').updateValueAndValidity();
      this.claimantsInformation.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.claimantsInformation.get('zip').updateValueAndValidity();
      this.claimantsInformation.get('city').reset();
      this.claimantsInformation.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('city').updateValueAndValidity();
      this.claimantsInformation.get('postalCode').reset();
      this.claimantsInformation.get('postalCode').clearValidators();
      this.claimantsInformation.get('postalCode').updateValueAndValidity();
      this.claimantsInformation.get('province').reset();
      this.claimantsInformation.get('province').clearValidators();
      this.claimantsInformation.get('province').updateValueAndValidity();
    }
  }

  getPhoneType2Value() {
    this.changed = true;
    const secondaryPhoneType = this.claimantsInformation.get('secondaryPhoneType')?.value;

    if (secondaryPhoneType !== '') {
      this.claimantsInformation.get('secondaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.claimantsInformation.get('secondaryPhone').clearValidators();
    }
    this.claimantsInformation.get('secondaryPhone').updateValueAndValidity();
  }

  //getRadioAgreeanceValue($event) {
  //  // if you need the event source and value it can be accessed.
  //  console.log($event.target.value);
  //  if ($event.target.value == 'Disagree') {
  //    this.showDivPurchaseUploadDocs = true;

  //  }
  //  if ($event.target.value == 'Agree') {
  //    this.showDivPurchaseUploadDocs = false;
  //    this.resetFormArray();
  //  }
  //}


  // Clear ClaimDetails Form Array Controls
  resetFormArray() {
    this.claimDetails().clear();
  }

  // Remove the second element and so on
  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  // Declare FormArray Function
  claimDetails(): FormArray {
    return this.claimantsInformation.get('claimDetails') as FormArray
  }

  // Create new Form Array
  newClaimDetail(): FormGroup {
    return this.fb.group({
      purchaseYear: ['', Validators.compose([Validators.required])],
      defendant: ['', Validators.compose([Validators.required])],
      purchaseAmount: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
    });
  }

  // Create a New Array Function
  claimDetailARR(index) {
    this.cdList = this.claimantsInformation.get('claimDetails') as FormArray;
    const formGroup = this.cdList.controls[index] as FormGroup;
    return formGroup;
  }

  addData() {
    (<FormArray>this.claimantsInformation.get('claimDetails')).push(this.newClaimDetail());
    this.showDivDisagreePurchaseMessage = false;
  }

  removeData(i: number) {
    this.claimDetails().removeAt(i)
  }

  getFileDetails(e) {
    console.log(this.supportingDocuments);
    for (var i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
      //console.log(e.target.files[i]);
      //if (this.supportingDocuments.length >= 1) {
      //  this.showDivUploadDocumentMessage = false;
      //}
    }
  }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }

  onSubmit() {
    let counterVariable: number = 0;
    let apArrayLength = (<FormArray>this.claimantsInformation.get('claimDetails')).length;
    //let choice = this.claimantsInformation.get('agreeance').value;
    this.submitted = true;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    if (apArrayLength === counterVariable) {
      // Display Error Message
      this.showDivDisagreePurchaseMessage = true;
      /*console.log("Array For the Table Is Empty");*/
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;
    //if (choice === "Disagree") {
    //  claimant.agreeance = 'AuditDisagree';
    //} else {
    //  claimant.agreeance = "AuditAgree";
    //}

    this.spinner.show();

    /*console.log(claimant);*/
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: Claimant) {
    const message = "Unable to save claimant data.";

    this.claimantService.createClaimant(claimant).subscribe(res => {

      this.submittedClaim = res;
      if (this.submittedClaim.statusMessage === message) {
        this.showSubmittalErrorWarning = true;
        return;
      }
      this.SubmitDocuments(this.submittedClaim.claimNumber);
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.claimantService.submitDocuments(this.submittedClaim.claimNumber, this.supportingDocuments).subscribe(() => {
    });
    this.storage.store('claimant', this.submittedClaim);
    // this.submitted = false;
    this.claimantsInformation.reset();
    this.spinner.hide();
    this.router.navigate(['/complete']);
  }
}
